//material ui
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

//type
import { amenityType } from '../api/amenities/type/AmenitiesType';

//tranlsate
import i18n from '../translate/i18n';

const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;

interface AmenitiesCardProps {
    element: amenityType
}
const AmenitiesCard = ({element} :AmenitiesCardProps) => {
  return (
    <div>
      <Card className='h-[210px] flex justify-center items-center !text-primaryColor !rounded-[15px]'>
        <CardContent className='flex flex-col w-full h-full justify-evenly'>
          <Typography className='!text-secondaryColor'>
              <img
                src={`${storageURL}/${element.icon}`}
                alt="no_photo"
                loading="lazy"
                decoding="async"
                className="w-[48px] h-[48px] m-auto object-cover"
              />
          </Typography>
          <Typography className={`${i18n.language === "en" ? "!font-pala": "!font-helvetica-arabic-bold"}`} variant="h5" component="div">
            {element.name}
          </Typography>
          <Typography className={`${i18n.language === "en" ? "!font-helvetica-light" : "!font-helvetica-arabic-light"}`} variant="body2">
            {element.short_description}
          </Typography>
        </CardContent>
      </Card>
    </div>
  )
}

export default AmenitiesCard



